import { render, staticRenderFns } from "./MailThemeHtmlEditor.vue?vue&type=template&id=5b264b1c&scoped=true&"
import script from "./MailThemeHtmlEditor.vue?vue&type=script&lang=js&"
export * from "./MailThemeHtmlEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailThemeHtmlEditor.vue?vue&type=style&index=0&id=5b264b1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b264b1c",
  null
  
)

export default component.exports